import { useTranslation } from "react-i18next";
import { DialogWrapper } from "../common/dialogWrapper";
import { Box } from "@mui/material";
import { TextWrapper } from "../formUtilities/useTextWrapper";
import { ButtonWrapper } from "../formUtilities/useButton";
import { Logout } from "../../../services/authService";
import { AppRoutes } from "../../../constants/appRoutes";
import { buildLocalizeRoute } from "../../../helpers/languageHelper";
import { useNavigate } from "react-router-dom";

export const LogoutDialog = ({ open = false, onClose = false, text = "" }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return <DialogWrapper
    maxWidth="xs"
    centerHeading={true}
    state={open}
    hideCloseBtn={true}
    preventOutsideClick={true}
    onClose={() => {
      onClose(false);
    }}
    title={t('logOut')}
    subTitleClass="!font-normal !text-black"
    actionFooterClass="!px-0"
    content={
      <Box className="text-center">
        <TextWrapper classList="!text-center" text={text ? t(text) : t('logOutAndLoginAgain')} />
      </Box>
    }
    actions={<ButtonWrapper onClick={() => {
      onClose(true);
      Logout();
      navigate(buildLocalizeRoute(AppRoutes.Login));
    }} label={t('backToLogin')} />}></DialogWrapper>;
};